import { render, staticRenderFns } from "./StudentExchangeNonPartnerWidget.vue?vue&type=template&id=84cc6f94&"
import script from "./StudentExchangeNonPartnerWidget.vue?vue&type=script&lang=ts&"
export * from "./StudentExchangeNonPartnerWidget.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports